module.exports = __webpack_public_path__ + "static/media/OneLogin-logo-symbol_only.1d8c306e.svg";